<template>
  <div>
    <div v-wechat-title="'【最强蜗牛】不思议乐园专题页'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="banner">
        <div class="part-banner"></div>
      </div>
      <div class="qrcode-box"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp , buriedLogger } from '@/utils/utils';
import { mapActions } from 'vuex';
export default {
  components: {},
  data () {
    return {
      enterLink: '',
    };
  },
  created () {
    const bl = buriedLogger("snail", "最强蜗牛_六周年专题页_PC端");
    this.logger = bl;
  },
  mounted () {
    this.$nextTick(() => {
      // 分享
      this.enterLink = 'https://h5.qingcigame.com/snail/yayaLand/enter';
      this.monitoringEquipment(this.enterLink);
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment(linkUrl) {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${linkUrl}${getTimeStamp()}`
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '【最强蜗牛】不思议乐园专题页',
        imgUrl: "https://download4.qcplay.com/qcgame-api/Ik2I1peidSk9NbfFxn8mESdoBdbUHLwOqXxNCtGh.png",
        desc: "进入不思议乐园，帮助小卖部老板丫丫，找回遗失的童年！",
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/yayaLand/pc/index.vue